export {default} from './TipErrorInfo';
